import { Injectable } from '@angular/core';
import { Navigator, SingleKeyNavigationHelper, KeyBase, Key } from '@kpd/framework-ngx';

@Injectable()
export class PermissionsNavigatorHelper extends SingleKeyNavigationHelper {
  constructor(navigator: Navigator) {
    super('permissions', navigator);
  }

  composeOverviewUrl(): string {
    return `permissions`;
  }

  composeDetailUrl(key: Key<string>): string {
    return `permissions/details/${key.id}`;
  }

  navigateToDetail(
    entityKey: KeyBase,
    editMode: boolean,
    overrideCurrentBrowserHistoryItem: boolean = false,
    replaceLastChildInBreadCrumb: boolean = false,
    params?: object,
  ): Promise<boolean> {
    return super.navigateToDetail(
      entityKey,
      editMode,
      overrideCurrentBrowserHistoryItem,
      replaceLastChildInBreadCrumb,
      params,
    );
  }
}
